import { BRAND } from "@/common/config";

export const cryptoPspList = [{
    alias: "nax",
    text: 'Crypto',
    symbol: 'BTC',
    tabs: [
        {
            name: 'BTC',
            text: 'Bitcoin'
        }
    ]

}, {
    alias: "cryptocurrency",
    text: 'Cryptocurrency',
    symbol: 'BTC',
    tabs: [
        {
            name: 'BTC',
            text: 'Bitcoin'
        },
        {
            name: 'LTC',
            text: 'Litecoin'
        },
        {
            name: 'DOGE',
            text: 'Dogecoin'
        },
        {
            name: 'BCH',
            text: 'Bitcoin Cash'
        },
        {
            name: 'ETH',
            text: 'Ethereum'
        },
        {
            name: 'MATIC',
            text: 'Polygon'
        },
        {
            name: 'BNB',
            text: 'BNB'
        },
    ]
}, {
    alias: "bithide",
    text: 'BitHide',
    symbol: 'BTC',
    tabs: ['stage'].includes(BRAND) ? [
        {
            name: 'BTC',
            text: 'BTC'
        },
        {
            name: 'ETH',
            text: 'ETH'
        },
        {
            name: 'LTC',
            text: 'LTC'
        },
        {
            name: 'TRX',
            text: 'TRX'
        },
        {
            name: 'USDT-TRC20',
            text: 'USDT-TRC20'
        },
        {
            name: 'USDT-ERC20',
            text: 'USDT-ERC20'
        },
        {
            name: 'USDC-ERC20',
            text: 'USDC-ERC20'
        },
    ] : [
        {
            name: 'BTC',
            text: 'BTC'
        },
        {
            name: 'USDT-TRC20',
            text: 'USDT-TRC20'
        },
    ]
}, {
    alias: "westwallet",
    text: 'West Wallet',
    symbol: 'BTC',
    tabs: [
        {
            name: 'BTC',
            text: 'Bitcoin'
        },
        {
            name: 'ETH',
            text: 'Ethereum'
        },
        {
            name: 'USDT-TRC20',
            text: 'USDT-TRC20'
        },
    ]
},
]
